@let corporateDesign = corporateDesignService.corporateDesign;
@let header = headerStore.header();
@let texts = textStore.texts();

@let isLoading =
  corporateDesignStore.isLoading() ||
  headerStore.isLoading() ||
  configStore.isLoading();
@if (isLoading) {
  <div class="pt-32">
    <aw-loading-animation
      [entityType]="EEntityType.header"
      [relationType]="ERelationType.loading"></aw-loading-animation>
  </div>
}
@if (header && corporateDesign() && !isLoading) {
  <div
    class="mb-2 flex w-full justify-center"
    [style.background-color]="
      corporateDesignService.isDarkModeActive()
        ? corporateDesign().colorAdmixtures.dark_surface_01
        : header.backgroundColor
    "
    [style.color]="corporateDesignService.darkFontColor(header.fontColor)"
    [style.font-size]="header.headlineFontSize | toFontSize">
    <div class="w-full max-w-[1440px]">
      <div class="container mx-auto flex min-h-10 items-center">
        <div class="hidden grow-0 md:flex">
          <img
            [src]="headerStore.leftPath()"
            [alt]="header.leftImage.imageAlts | language"
            [attr.data-testid]="'leftImage'"
            class="max-h-10 pr-2" />
        </div>
        <div class="flex grow justify-between">
          <div class="flex items-center gap-2">
            <a [routerLink]="['/']">
              <img
                [src]="headerStore.logoPath()"
                [alt]="header.logo.imageAlts | language"
                [attr.data-testid]="'logoImage'"
                class="max-h-10" />
            </a>
            <span
              class="hidden md:block"
              [style.font-size]="header.headlineFontSize | toFontSize"
              [attr.aria-label]="header.headlines | language"
              [attr.data-testid]="'headline'">
              {{ header.headlines | language }}</span
            >
          </div>
          <aw-ticket-type-toggle></aw-ticket-type-toggle>
          <div class="flex items-center">
            <aw-dark-mode-toggle class="mr-6" />
            <aw-shop-language-drop-down
              class="mr-6 min-w-32"></aw-shop-language-drop-down>
            @if (
              configStore.getBooleanConfiguration(
                CONFIGURATION_SETTING_KEYS.IsLoginActive
              )
            ) {
              @if (!auth.isLoggedIn()) {
                <aw-button
                  [id]="'login'"
                  [style]="'primary'"
                  [buttonSize]="'small'"
                  [type]="'button'"
                  [text]="
                    texts
                      | filterTexts
                        : ERelationType.loginButton
                        : EEntityType.loginLogout
                      | language
                  "
                  (click)="handleLoginButtonClick()">
                  <span class="material-symbols-rounded pr-2">
                    {{
                      configStore.getStringConfiguration(
                        CONFIGURATION_SETTING_KEYS.LoginButtonIcon
                      )
                    }}
                  </span>
                </aw-button>
              } @else {
                <div class="flex gap-2">
                  <aw-button
                    [id]="'accountButton'"
                    [style]="'primary'"
                    [buttonSize]="'small'"
                    [type]="'button'"
                    [style.border-radius]="'0.5rem'"
                    (click)="navigate('/' + ERoute.account)"
                    (keydown.enter)="navigate('/' + ERoute.account)">
                    <span class="material-symbols-rounded pr-2">
                      {{
                        configStore.getStringConfiguration(
                          CONFIGURATION_SETTING_KEYS.AccountIcon
                        )
                      }}
                    </span>
                    <span class="hidden md:block" [style.line-height]="'1'">{{
                      texts
                        | filterTexts
                          : ERelationType.privateAreaLabel
                          : EEntityType.privateArea
                        | language
                    }}</span>
                  </aw-button>
                  <aw-button
                    [id]="'logoutButton'"
                    (keydown.enter)="logout()"
                    (click)="logout()"
                    [style]="'primary'"
                    [buttonSize]="'small'"
                    [type]="'button'">
                    <span
                      class="material-symbols-rounded"
                      [style.line-height]="'1'"
                      [attr.aria-label]="'Logout'">
                      {{
                        configStore.getStringConfiguration(
                          CONFIGURATION_SETTING_KEYS.LogoutButtonIcon
                        )
                      }}
                    </span>
                  </aw-button>
                </div>
              }
            }
          </div>
        </div>
        <div class="hidden grow-0 pl-2 md:flex">
          <img
            [src]="headerStore.rightPath()"
            [alt]="header.rightImage.imageAlts | language"
            [attr.data-testid]="'rightImage'"
            class="max-h-10" />
        </div>
      </div>
    </div>
  </div>
}
